export default __webpack_public_path__ + "static/media/ISSO CLASS-4_SYLLABUS_2025-26.00a94e5b.pdf";